var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "ob1-cards",
        {
          style: { "background-image": "url(" + _vm.offer.banner + ")" },
          attrs: {
            "additional-classes": "shadow-none push-background bg-greige h-100",
            "with-composite-link": false,
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column h-100 py-2 px-1 px-xl-2" },
            [
              _c("div", { staticClass: "flex-grow-1" }, [
                _c("p", {
                  staticClass: "py-0 mb-0 fw-bold",
                  domProps: { innerHTML: _vm._s(_vm.offer.teaser) },
                }),
              ]),
              _vm._v(" "),
              _vm.offer.offerPageUrl
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("lien", {
                          attrs: {
                            label: _vm.offer.name,
                            href: _vm.offer.offerPageUrl,
                            "tms-category": "push_tuile",
                            "is-link-arrow": true,
                            "open-new-tab": true,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }